import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'
import { ITabsSection } from './tabs.interface'

@UntilDestroy()
@Component({
  selector: 'lla-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TabsComponent {
  @Input() sections: ITabsSection[] = []
  @Input() selectedSection: string
  @Input() smallScreensSpaceBetween = false
  @Input() extraTabItemClass = ''
  @Output() selectedSectionChanged = new EventEmitter<string>()
}
